<template>
    <div>
        <limitless-page-header>
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'birthday_lists.edit', params: { id: 0 } }" icon="icon-plus3">Ny lista</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/birthday_lists'" :columns="table_columns" :filter="table_filter" sort-by="birthday_id" sort-order="desc" @updateFilter="table_filter=$event" @rowclick="rowClick" history :per-page="100">
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>
                <template #cell_active="{ row }">
                    <span v-if="row.active" class="text-success"><i class="icon-check"></i></span>
                    <span v-else class="text-danger"><i class="icon-cross"></i></span>
                </template>
                <template #cell_CompanyName="{ row }">
                    <router-link :to="{ name: 'customers.edit', params: { id: row.customer_id } }">{{ row.CompanyName }}</router-link>
                </template>
                <template #cell_card_order_id="{ row }">
                    <router-link :to="{ name: 'cardorders.edit', params: { id: row.card_order_id } }">{{ row.card_order_id }}</router-link>
                </template>
                <template #cell_card_series_id="{ row }">
                    <router-link :to="{ name: 'cardseries.edit', params: { id: row.card_series_id } }">{{ row.card_series_id }}</router-link>
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    name: 'BirthdayLists',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
        },
        table_columns: [
            {
                data: 'birthday_id',
                header: '#',
                sortable: true,
            },
            {
                data: 'active',
                header: 'Aktiv',
                sortable: true,
            },
            {
                data: 'CompanyName',
                header: 'Kund',
                sortable: true,
            },
            {
                data: 'card_series_id',
                header: 'Kortserie',
                sortable: true,
            },
            {
                data: 'card_order_id',
                header: 'Pågående order',
                sortable: true,
            },
            {
                data: 'end_date',
                header: 'Slutdatum',
                sortable: true,
            },
        ],
    }),
    methods: {
        rowClick(data, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                const route = this.$router.resolve({ name: 'birthday_lists.edit', params: { id: data.birthday_id } });
                window.open(route.href, '_blank').focus();
            } else {
                this.$router.push({ name: 'birthday_lists.edit', params: { id: data.birthday_id } });
            }
        },
    },
};

</script>
